<template>
  <DateCell
    :date-prop="OKR_DATES_SELECT_DATE_PROPS.START_DATE"
    :item="item"
    :readable="readable"
    :updatable="updatable"
    :view-config
    @update-dates="$emit('update-dates', $event)"
  />
</template>

<script>
import { defineComponent } from 'vue'

import { OKR_DATES_SELECT_DATE_PROPS } from '@/utils/okr-element-dates'
import { objectOrNullProp } from '@/utils/prop-validators'

import DateCell from '@/components/objectives/table/cells/DateCell'

export default defineComponent({
  name: 'StartDateCell',
  components: { DateCell },

  props: {
    item: {
      type: Object,
      required: true
    },

    readable: {
      type: Boolean
    },

    updatable: {
      type: Boolean
    },

    viewConfig: {
      validator: v => objectOrNullProp(v),
      default: null
    }
  },

  emits: {
    'update-dates': null
  },

  computed: {
    OKR_DATES_SELECT_DATE_PROPS: () => OKR_DATES_SELECT_DATE_PROPS
  }
})
</script>
